@import "../fonts.css";
@import "../colors.css";

div.dialog-header {
	border-image: var(--divider-gradient);
	border-bottom: 6px solid;
	padding: 15px 20px 10px 20px;
}

h2.dialog-title {
	font-style: normal;
	font-weight: 600;
	font-size: 20px;
	color: var(--primary-header-color);

	text-align: center;
	line-height: 1.2;
	margin: 0px;

	font-family: "Inter", sans-serif;
}

div.dialog-footer {
	border-top: 0.5px solid var(--light-divider-color);
}

button.close-button {
	position: absolute;
	top: 2.5px;
	right: 10px;
	font-size: 30px;
}

div.message-dialog-content {
	font-size: 18px;
	padding-bottom: 10px;
}

.dialog-title .message-dialog-content {
	padding-top: 20px;
}

button.back-button {
	position: absolute;
	top: 10px;
	left: 16px;
	width: fit-content;
	color: black;
	text-transform: none;
}

button.back-button:hover {
	background-color: unset;
}

button.back-button:focus-visible {
	outline: 2px solid var(--focus-outline-color-dark);
	outline-offset: 2px;
}

button.back-button :global(.MuiButton-icon) {
	margin-right: 2.5px;
}

button.back-button :global(.MuiButton-icon) svg {
	font-size: 15px;
}
